import React from 'react'
import PropTypes from 'prop-types'
import cookie from 'react-cookie'
import 'url-polyfill'
import { INIT_AUTH_FLOW_PARAMS } from '../../actions'

const withSeparateAuthFlow = (Component) => {
  const wrapped = class extends React.Component {
    componentDidMount() {
      this.props.handleAction(INIT_AUTH_FLOW_PARAMS, this.props.location.query)
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.redirectUri
        && !this.props.authData
        && nextProps.authData) {
        const url = new URL(this.props.redirectUri)

        url.searchParams.append('access_token', nextProps.authData.access_token)
        url.searchParams.append('refresh_token', nextProps.authData.refresh_token)
        cookie.remove('redirectUri')

        window.location = url.toString()
      }
    }

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
        />
      )
    }
  }

  wrapped.propTypes = {
    handleAction: PropTypes.func,
    redirectUri: PropTypes.string,
    authData: PropTypes.shape(),
    location: PropTypes.shape({
      query: PropTypes.object.isRequired,
    }).isRequired,
  }

  wrapped.defaultProps = {
    handleAction: PropTypes.func,
    redirectUri: null,
    authData: null,
  }

  return wrapped
}

withSeparateAuthFlow.propTypes = {
  Component: PropTypes.element,
}

withSeparateAuthFlow.defaultProps = {
  Component: PropTypes.element,
}

export default withSeparateAuthFlow



// WEBPACK FOOTER //
// ./src/components/hoc/separate-auth-flow.js